module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0016.jpg?v=1d2007fe";